// extracted by mini-css-extract-plugin
export default {"title":"SubscriptionSettings_title__A3WO+","controls":"SubscriptionSettings_controls__PSspE","subscrWrapper":"SubscriptionSettings_subscrWrapper__r2kfG"};